import React , { useEffect , useState } from "react";
import QuickBibleNoteForm from "./notes/QuickBibleNoteForm";
import { useUserId } from "../../hooks/useUserId";

import { collection, query, where, getDocs } from "firebase/firestore";
import { db, COLLECTIONS } from "../../firebase";


const FloatingBibleReader = () => {


    const [showBible, setShowBible] = useState(false);
    const [showQuickBibleNote, setShowQuickBibleNote] = useState(false);
    const [quickBibleNotes, setQuickBibleNotes] = useState([]);
    const userId = useUserId(); // Assure-toi que c’est une fonction

    const sidebarWidth = 250;

    const toggleBibleDiv = () => setShowBible(prev => !prev);

    // Récupérer les notes rapides pour l’utilisateur
    const fetchQuickNotes = async () => {
        if (!userId) return;
        try {
            const q = query(
                collection(db, COLLECTIONS.NOTES),
                where("userId", "==", userId),
                where("category", "==", "Lecture Biblique") // catégorie prédéfinie
            );
            const snapshot = await getDocs(q);
            setQuickBibleNotes(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        } catch (err) {
            console.error("Erreur fetch QuickBibleNotes :", err);
        }
    };

    useEffect(() => {
        fetchQuickNotes();
    }, [userId, showQuickBibleNote]);


    return (
        <>
            {/* Bouton NOTE BIBLIQUE (visible uniquement si Bible ouverte) */}
            {showBible && (
                <button
                    className="btn flat-btn flat-note-btn"
                    onClick={ () => setShowQuickBibleNote ( true ) }
                    title="Ajouter une note biblique"
                >
                    ✍️

                    {/* Pastille compteur */ }
                    { quickBibleNotes.length > 0 && (
                        <span className="note-count">{ quickBibleNotes.length }</span>
                    ) }
                </button>
            ) }


            {/* Bouton BIBLE */ }
            <button
                className="btn flat-btn flat-bible-btn"
                onClick={() => setShowBible((prev) => !prev)}
                title={showBible ? "Fermer la Bible" : "Lire la Bible"}
            >
                {showBible ? "❌" : "📖"}
            </button>

            {/* Iframe Bible */}
            <div
                className={`bible-iframe-wrapper ${showBible ? "active" : ""}`}
                style={{
                    left: `${sidebarWidth}px`,
                    width: `calc(100% - ${sidebarWidth}px)`,
                }}
            >
                <iframe
                    src="https://bible.likalo.fr/content-only"
                    title="Lecture Biblique"
                    allowFullScreen
                />
            </div>

            {/* Modal note rapide */}
            {showQuickBibleNote && (
                <QuickBibleNoteForm
                    userId={userId}
                    onClose={() => setShowQuickBibleNote(false)}
                />
            )}

            {/* Styles */}
            <style>{`
        .flat-btn {
          position: fixed;
          right: 20px;
          z-index: 1002;
          border: none;
          color: white;
          font-size: 1.4rem;
          font-weight: bold;
          border-radius: 50%;
          width: 55px;
          height: 55px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.2);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.2s ease, background-color 0.3s ease;
        }

        .flat-btn:hover {
          transform: translateY(-2px);
        }

        /* Bouton Bible */
        .flat-bible-btn {
          bottom: 80px;
          background-color: #007bff;
        }

        .flat-bible-btn:hover {
          background-color: #0056b3;
        }

        /* Bouton Note (au-dessus) */
        .flat-note-btn {
          bottom: 150px; /* AU-DESSUS */
          background-color: #28a745;
        }

        .flat-note-btn:hover {
          background-color: #218838;
        }
        .note-count {
          position: absolute;
          bottom: -5px; /* juste en dessous du bouton */
          left: 50%;
          transform: translateX(-50%);
          background: red;
          color: white;
          font-size: 0.5rem;
          font-weight: bold;
          padding: 2px 5px;
          border-radius: 50%;
          min-width: 18px;
          text-align: center;
        }
        /* Wrapper iframe */
        .bible-iframe-wrapper {
          position: fixed;
          top: 0;
          height: 100vh;
          background: #fff;
          box-shadow: -4px 0 15px rgba(0,0,0,0.2);
          z-index: 1000;
          transform: translateX(100%);
          transition: transform 0.4s ease;
          overflow: hidden;
        }

        .bible-iframe-wrapper.active {
          transform: translateX(0);
        }

        .bible-iframe-wrapper iframe {
          width: 100%;
          height: 100%;
          border: none;
        }
      `}</style>
        </>
    );
};

export default FloatingBibleReader;
